import React from "react"
import { close } from "@app/scripts/hooks/icons"
import { useSearchspringFilters } from "@app/scripts/hooks/use-searchspring-filters"
import { sizeLabel } from "@app/scripts/lib/utils"

export function FilterSortDrawerActiveItems() {
  const {
    activeFilters,
    handleToggleFilter,
    handleRemoveFilter,
    handleClearFilters,
  } = useSearchspringFilters()

  // Sanitize activeFilters to make sure they show front end friendly.
  // Size filters relabel to alpha and merge to one chip per label (#1747);
  // removing a merged chip toggles all its active keys in one update.
  const sizeGroups = new Map<string, string[]>()
  const activeFiltersArray: { key: string; label: string }[] = []

  Array.from(activeFilters ?? []).forEach((item) => {
    const [field, rawValue = ""] = item.split(":")
    let label = rawValue.toLowerCase()

    if (field === "ss_filter_sizes") {
      const sizeLabelText = sizeLabel(rawValue)
      const group = sizeGroups.get(sizeLabelText) || []
      group.push(item)
      sizeGroups.set(sizeLabelText, group)
      return
    }

    if (field === "ss_price") {
      const [low, high] = rawValue.split("<>")
      if (low && high) {
        label = `$${low} - $${high}`
      }
    }

    activeFiltersArray.push({ key: item, label })
  })

  const sizeChips = Array.from(sizeGroups.entries()).map(([label, keys]) => ({
    key: keys.join(","),
    label,
  }))

  if (activeFiltersArray.length === 0 && sizeChips.length === 0) return null

  return (
    <div className="filter-sort-drawer-active-items--list">
      {activeFiltersArray.map(({ key, label }) => (
        <div
          onClick={() => handleRemoveFilter(key)}
          key={key}
          className="filter-sort-drawer--active-item"
        >
          {label} <span>{close}</span>
        </div>
      ))}
      {sizeChips.map(({ key, label }) => (
        <div
          onClick={() => handleToggleFilter(key)}
          key={key}
          className="filter-sort-drawer--active-item"
        >
          {label} <span>{close}</span>
        </div>
      ))}
      <p
        className="filter-sort-active-items--close underline"
        onClick={handleClearFilters}
      >
        Clear All
      </p>
    </div>
  )
}
